export const EASYMODER = 'easymoder'
export const CHATKEEPER = 'chatkeeper'
